import React, { useMemo } from 'react';
import { View, Text, useWindowDimensions } from 'react-native';
import CustomPressable from '../customPressable/customPressable';
import { ImageComp } from '../Image/Image';
import { useCssStyle } from '../../customHook/getCssStyle';
import { getCleanUrl } from '../../utils/Helper';
import RenderHTML from 'react-native-render-html';
import { useDispatch, useSelector } from 'react-redux';
import { EARLY_CHECKIN, ISINROOMTAB, PRE_CHECKIN } from '../../config/Constant';
import { formatTime } from '../../js/formatTime';
import { useTranslation } from 'react-i18next';
import { useNavigation } from '@react-navigation/native';
import { CHECK_IN } from '../../navigation/StackNavigator/routes';
import { setShowLoginModal } from '../../Redux/Reducers/appConfigReducer';
import SliderPressable from '../customPressable/sliderPressable';
import { inAppBrowserFunc } from '../../js/inAppBrowser/inAppBrowser';
import { setRenderFlashMessage } from '../../Redux/Actions/appConfigAction';
import { setGuestRoomData } from '../../Redux/Reducers/guestRoomReducer';
import { formatDate } from '../../js/formatDate';


const GuestDetailsWidget = (props) => {
  const { widget, listItemData = [], handleOnWidgetClick } = props || {};
  const getStyles = useCssStyle();
  const { width } = useWindowDimensions()
  const { t } = useTranslation();
  const navigation = useNavigation();
  const dispatch = useDispatch();

  const { isLoggedIn } = useSelector(state => state.appConfigSlice);
  const { preCheckInCompleted, preCheckInData } = useSelector(state => state.checkInSlice.preCheckInStatus);
  const { preCheckInWidgetState } = useSelector(state => state.checkInSlice);
  const { currentGuestDetails } = useSelector(state => state.guestDetailsSlice,);

  const { webAppWidgetsInfo, extraConfigParam } = useSelector((state) => state.deviceConfigSlice);
  const dateFormat = extraConfigParam?.DATE_FORMAT;
  
  const { bookYourStayLink, allowUserLoginViaFindingReservation } = webAppWidgetsInfo?.appConfigs || {};

  const { isBookingFound, bookingData } = useSelector(state => state.checkInSlice.bookingStatus);



  
  
  let arrival = currentGuestDetails?.checkInDate
  let checkout = currentGuestDetails?.plannedCheckOutDate


  const proceedCheckIn = () => {
    navigation.navigate(CHECK_IN, { attemptCheckin: true });
  }

  const proceedCheckInWidget = () => {
    navigation.navigate(CHECK_IN);
  }

  const handleMakeRes = () => {
    if(bookYourStayLink){
      inAppBrowserFunc(bookYourStayLink);
    } else {
      dispatch(setRenderFlashMessage(true, { type: "danger", message: "Booking link is unavailable." }));
    }
  }

  const handleLinkToRoom = () => {
    dispatch(setGuestRoomData({
        guestDetails: bookingData,
        activeState: 'get_login_roomnumber'
    }));
    dispatch(setShowLoginModal(true));
  }

  if (!listItemData.length) {
    return null;
  }

  return (
    <>
      {
        listItemData.map(widgetData => {
          let widgetImg = widgetData.btnImageUrl ? getCleanUrl(widgetData.btnImageUrl) : null;
          const customWidgetTitleStyle = getStyles([
            'guestDetailsHeaderTitle',
            `guestDetailsHeaderTitle_${widgetData.widgetMetaHtmlId}`,
            `guestDetailsHeaderTitle_${widgetData.id}`
          ]);

          const customWidgetSubTitleStyle = getStyles([
            'guestDetailsHeaderSubtitle',
            `guestDetailsHeaderSubtitle_${widgetData.widgetMetaHtmlId}`,
            `guestDetailsHeaderSubtitle_${widgetData.id}`
          ]);

          const baseTitleStyle = {
            ...customWidgetTitleStyle,
            fontFamily: Array.isArray(customWidgetTitleStyle.fontFamily)
              ? customWidgetTitleStyle.fontFamily[0]
              : customWidgetTitleStyle.fontFamily
          }
          const systemFonts = Array.isArray(customWidgetTitleStyle.fontFamily)
              ? customWidgetTitleStyle.fontFamily
              : [customWidgetTitleStyle.fontFamily]

          return (
            <View key={widgetData.id} style={getStyles(['guestDetailsWidgetContainer', `guestDetailsWidgetContainer_${widgetData.widgetMetaHtmlId}`, `guestDetailsWidgetContainer_${widgetData.id}`])} id={`guestDetailsWidgetContainer guestDetailsWidgetContainer_${widgetData.widgetMetaHtmlId} guestDetailsWidgetContainer_${widgetData.id}`} >
              {widgetImg && (
                <ImageComp
                  source={widgetImg}
                  style={getStyles(['guestDetailsImageStyle', `guestDetailsImageStyle_${widgetData.widgetMetaHtmlId}`, `guestDetailsImageStyle_${widgetData.id}`])}
                  id={`guestDetailsImageStyle guestDetailsImageStyle_${widgetData.widgetMetaHtmlId} guestDetailsImageStyle_${widgetData.id}`}
                />
              )}
              {widgetData.widgetTitle && (
                <RenderHTML
                  contentWidth={width}
                  baseStyle={baseTitleStyle}
                  source={{ html: widgetData.widgetTitle }}
                  systemFonts={systemFonts}
                  id={`guestDetailsHeaderTitle guestDetailsHeaderTitle_${widgetData.widgetMetaHtmlId} guestDetailsHeaderTitle_${widgetData.id}`}
                />
              )}
              {widgetData.widgetDesc && (
                <View style={customWidgetSubTitleStyle}>
                  <RenderHTML
                    contentWidth={width}
                    baseStyle={customWidgetSubTitleStyle}
                    source={{ html: widgetData.widgetDesc }}
                    systemFonts={[customWidgetSubTitleStyle.fontFamily]}
                    id={`guestDetailsHeaderSubtitle guestDetailsHeaderSubtitle_${widgetData.widgetMetaHtmlId}`}

                  />
                </View>
              )}
              {(arrival && checkout) ? 
                <View style={getStyles(['guestDetailsDateContainer'])} id='guestDetailsDateContainer'>
                  <View style={getStyles(["guestDetailsDateItemContainer"])} id='guestDetailsDateItemContainer'>
                    <Text id='guestDetailsDateItemTitle' style={getStyles(['guestDetailsDateItemTitle'])}>{formatDate(arrival.split("T")[0], dateFormat)}</Text>
                  </View>

                  <View style={getStyles(["guestDetailsDateItemContainer", "guestDetailsDateItemDurationContainer"])} id='guestDetailsDateItemContainer guestDetailsDateItemDurationContainer'>
                    <Text id='guestDetailsDateItemTitle' style={getStyles(['guestDetailsDateItemTitle'])}>Duration</Text>
                    <Text id='guestDetailsDateItemSubTitle guestDetailsDateItemDurationSubTitle' style={getStyles(['guestDetailsDateItemSubTitle', "guestDetailsDateItemDurationSubTitle"])}>
                      {(() => {
                        const start = new Date(arrival);
                        const end = new Date(checkout);

                        start.setHours(0, 0, 0, 0);
                        end.setHours(0, 0, 0, 0);

                        const diffTime = end - start;
                        const nights = Math.max(Math.floor(diffTime / (1000 * 60 * 60 * 24)), 0);
                        return `${nights} Night${nights !== 1 ? 's' : ''}`;
                      })()}
                      </Text>
                  </View>
                  
                  <View style={getStyles(["guestDetailsDateItemContainer"])} id='guestDetailsDateItemContainer'>
                    <Text id='guestDetailsDateItemTitle' style={getStyles(['guestDetailsDateItemTitle'])}>{formatDate(checkout.split("T")[0], dateFormat)}</Text>
                  </View>
                </View> 
                : null
              }
              {
                isLoggedIn ? null : 
                preCheckInCompleted ?
                    <View style={getStyles(['guestDetailsButtonContainer'])} id="guestDetailsButtonContainer">
                      <SliderPressable disabled={preCheckInWidgetState == PRE_CHECKIN} text={preCheckInWidgetState == EARLY_CHECKIN ? t('guest_details.request_early_checkin') : t('guest_details.proceed_checkin')} handleOnSuccess={proceedCheckIn} />

                      {!ISINROOMTAB && <>
                          <Text style={getStyles(['guestDetailsButtonContainerText'])} id='guestDetailsButtonContainerText'>{t('guest_details.have_room')}</Text>

                          <CustomPressable onPress={handleLinkToRoom} style={getStyles(['secondaryBtn'])} id="secondaryBtn">
                            <Text style={getStyles(['secondaryBtnTxt'])} id='secondaryBtnTxt'>{t('guest_details.link_to_room')}</Text>
                          </CustomPressable>
                      </>}
                    </View>
                    :
                    isBookingFound ?
                      <View style={getStyles(['guestDetailsButtonContainer'])} id='guestDetailsButtonContainer'>
                        <SliderPressable text={t('guest_details.proceed_pre_checkin')} handleOnSuccess={proceedCheckInWidget} />

                        {!ISINROOMTAB && <>
                          <Text style={getStyles(['guestDetailsButtonContainerText'])} id='guestDetailsButtonContainerText'>{t('guest_details.have_room')}</Text>

                          <CustomPressable onPress={handleLinkToRoom} style={getStyles(['secondaryBtn'])} id="secondaryBtn">
                            <Text style={getStyles(['secondaryBtnTxt'])} id='secondaryBtnTxt'>{t('guest_details.link_to_room')}</Text>
                          </CustomPressable>
                        </>}
                      </View>
                      : !ISINROOMTAB &&
                      <View style={getStyles(['guestDetailsButtonContainer'])} id='guestDetailsButtonContainer'>
                        <CustomPressable style={getStyles(['primaryBtn'])} id="primaryBtn" onPress={() => dispatch(setShowLoginModal(true))}>
                          <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>{allowUserLoginViaFindingReservation ? t('guest_details.find_reservation') : t('guest_details.link_to_room')}</Text>
                        </CustomPressable>

                        {bookYourStayLink &&
                          <>
                            <Text style={getStyles(['guestDetailsButtonContainerText'])} id='guestDetailsButtonContainerText'>{t('guest_details.have_booking')}</Text>

                            <CustomPressable onPress={handleMakeRes} style={getStyles(['secondaryBtn'])} id="secondaryBtn">
                              <Text style={getStyles(['secondaryBtnTxt'])} id='secondaryBtnTxt'>{t('guest_details.make_reservation')}</Text>
                            </CustomPressable> 
                          </>
                        }
                      </View>
              }
            </View>
          )
        })
      }
    </>
  );
};

export default React.memo(GuestDetailsWidget);